import { openDB } from 'idb';

export const getUUID = async () => {
    const db = await openDB('uuidDatabase', 6);
    const uuids = await db.getAll('uuidStore');
    return uuids;
};